<template>
<div class="container-fluid">

  <div class="container-fluid bg-base-green trees-bg">
    <div class="row pt-5 pb-5">
      <div class="col-12">
        <h1 class="sub-title"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-left-circle" viewBox="0 0 16 16">
          <path fill-rule="evenodd" d="M1 8a7 7 0 1 0 14 0A7 7 0 0 0 1 8zm15 0A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-4.5-.5a.5.5 0 0 1 0 1H5.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L5.707 7.5H11.5z"/>
        </svg><router-link :to="{ name: 'Involucrados' }">{{$t('involucrado_page_h1')}}</router-link></h1>
      </div>      
    </div>
  </div>


  <div class="container">

    <div class="row mt-5 mb-5">      
      <div class="col-12 col-md-6">
        <label class="total">{{$t('involucrado_page_nombre')}}</label>
        <h6 class="regentes_involucrados">{{ involucrado.nombre_actor }}</h6>   
        <label class="total">{{$t('involucrado_page_esta')}}</label>
        <ul class="listas">
          <li v-for="g in grupos" :key="g.value">
            {{ $t(g.value) }}  ({{ g.count }})
          </li>
        </ul> 
      </div>
      
      <div class="col-12 col-md-5">
        
        <div class="total">{{$t('involucrado_page_participo_1')}} {{ planes.length }} {{$t('involucrado_page_participo_2')}}</div>
        <ul class="listas">
          <li v-for="(m, ix) in modalidades" :key="`modalidad_${ix}`">
            {{ translateModalidad(m.modalidad) }} ({{ m.count }})
          </li>
        </ul>
      </div>
    </div>  
  </div>

  <div class="container-fluid bg-ubicacion">
    <div class="row departamentos-map">
      <div class="col-12">         
        <b-tabs content-class="mt-2 ">
          <b-tab :title="$t('involucrados_region_influencia')">
            <div class="row">
              <div class="col-12 col-md-4">
                <MapaDepartamento :departamentos="byDepartamento"></MapaDepartamento>
              </div>
              <div class="col-12 col-md-8">
                <label class="total">{{$t('involucrado_page_opero')}}</label>
                
                <b-tabs content-class="mt-3">
                  <b-tab :title="`${dep.nombre} (${dep.planes})`" v-for="dep in byDepartamento" :key="`dep_${dep.nombre}`">
                    <div class="provincia row m-0">
                      <div class="col-12 p-0" v-for="prov in dep.provincia" :key="`prov_${prov.nombre}`">
                        <div class="row mb-3 border-bottom">
                          <div class="col-4">
                            <b>{{ prov.nombre }} ({{prov.count}})</b>
                          </div>
                          <div class="col-8">
                            <span v-for="dis in prov.distritos" :key="`distrito_${dis.nombre}`">
                            {{ dis.nombre }} ({{dis.count}}), 
                            </span>
                          </div>
                        </div>    
                      </div>
                    </div>
                  </b-tab>                  
                </b-tabs>

              </div>
            </div>
            
          </b-tab>
          <b-tab :title="$t('involucrados_red_influencia')">
            <div>
              <redesInvolucrado :involucrados="involucrados" :planes="planes" :involucrado="involucrado"/>
            </div>
          </b-tab>                                    
        </b-tabs>            
      </div>
    </div>
  </div>

  <div class="container">

    <div class="row mt-5 planes-results">
      <div class="col-12">
        <b-alert variant="success" show><div class="text-center">{{$t('involucrado_page_explore_1')}} {{ planes.length }} {{$t('involucrado_page_explore_2')}} {{ involucrado.nombre_actor }} {{$t('involucrado_page_explore_3')}} </div></b-alert>
      </div>
      <div class="col-12">
        <b-tabs pills vertical content-class="mt-3">
          <b-tab :key="year+'-group'" v-for="(planes, year) in byYears" :title="year">
            <template #title>
              {{ year }} ({{ planes.length }})
            </template>
            
            <div class="row regente-plan-item justify-content border-bottom pt-3 pb-3 planes-results" :key="id" v-for="(plan, id) in planes">
              <div class="col-12 col-md-4">
                  <label class="label-planes">{{$t('involucrado_page_titular')}}</label>
                  <h5> {{$t(plan.titular_actual)}}</h5>
                  <label class="label-planes">{{$t('involucrado_page_numero_th')}}</label>
                  <h5> {{plan.numero_th}}</h5>
                  <label class="label-planes">{{$t('involucrado_page_modalidad')}}</label>
                  <h5> {{$t(plan.modalidad)}}</h5>                
                  
              </div>
              <div class="col-12 col-md-3">
                <label class="label-planes">{{$t('involucrado_page_resolucion')}}</label>
                <h5>{{plan.resolucion_poa}}</h5>
                <label class="label-planes">{{$t('involucrado_page_fecha_aprob')}}</label>
                <h5>{{plan.date_aprob_raw}}</h5>
                <label class="label-planes">{{$t('involucrado_page_fecha_sup')}}</label>
                <h5>{{plan.fecha_sup_raw}}</h5>
              </div>
                
              <div class="col-12 col-md-3">
                  
                  <label class="label-planes">{{$t('involucrado_page_distri_prov')}}</label>
                  <h5>{{plan.distrito}}/{{plan.provincia}}</h5>
              </div>
              <div class="col-12 col-md-2 align-self-center">
                <router-link class="btn" :to="{ name: 'PlanPageDetalles' , params:{ id: plan.resolucion_poa_id}}">{{$t('involucrado_page_ver_pmf')}}
                </router-link>
              </div>
            </div>
          </b-tab>
        </b-tabs>
      </div>
    </div>

  </div>

</div>
</template>

<script>
  import { filter, find, groupBy, map, maxBy,  sum, uniq, orderBy } from 'lodash'
  import MapaDepartamento from '../components/MapaInfluencia.vue'
  import redesInvolucrado from '../components/redesInvolucrado.vue'
  import * as d3 from 'd3'

  export default {
    name: 'InvolucradoPage',
    props: {
      dataset: {
        type: Array
      }
    },
    data() {
      return {
        filters: [
          {value: "consultor_pmf_id", text: this.$t('consultor_pmf_id'), color: "#5e03b9"},
        {value: "profesional_inf_tecnico_insp_ocular_id", text: this.$t('profesional_inf_tecnico_insp_ocular_id'), color: '#848484'},
        {value: "profesional_recomienda_aprueba_pmf_id", text: this.$t('profesional_recomienda_aprueba_pmf_id'), color: "#377eb7"},
        {value: "funcionario_aprobo_pmf_id", text: this.$t('funcionario_aprobo_pmf_id'), color: "#377eb7"},
        {value: "representante_legal_id", text: this.$t('representante_legal_id'),  color: "#f780bf"},
        {value: "titular_actual_id", text: this.$t('titular_actual'), color: "#4daf4a"}
        ],
        grupos_list: []
      }
    },
    components: {
      MapaDepartamento,
      redesInvolucrado
    },
    methods: {
      departamentoSlug(dep) {
        return dep.replace(" ","_").toLowerCase().replace(" ","_")
      },
      translateModalidad(m) {
        return this.$t(m)
      }
    },
    computed: {
      involucrados() {
        let involucrados = []

        let current_locale = this.$route.params.locale

        map(this.filters, f => {
          console.log( f)
          let actores =  groupBy(this.planes, f.value)
          
          let max = maxBy(map(actores, (items, id) => {
            return {
              id: id,
              value: items.length
            }
          }),
          'value')

          let scale = d3.scaleLinear().domain([1, max.value]).range([5, 20])

          map(actores, (items, id) => {
            
            let nombre = uniq(map(items, f.value.replace("_id",""))).join("")
            
            let poa = uniq(map(items, 'resolucion_poa_id'))

            map(poa, p => {
              
              if(nombre != 'ND') {
                involucrados.push({
                  id: id,
                  plan_id: p,
                  name: `<b>${f.text}:</b><br />${nombre} <br /><br /> <b>${this.$t('pmf_aprobados')}</b> ${items.length}</b><br /><br /><div><b><a href="/#/${current_locale}/involucrado/${id}">${this.$t('ver_perfil')}</a></b></div>`,
                  category: f.text,
                  color: f.color,
                  marker: {
                    radius: scale(items.length)
                  }
                })
              }
            })
          })
        })

        return involucrados
      },
      planes() {
        let planes = {}
        let deduplicates = []
        let list_th = []

        map(this.filters, f => {

          let filtered = filter(this.dataset, [f.value, this.$route.params.id])

          map(filtered, item => {

            this.grupos_list.push({
              "value": f.value,
              "text": f.text,
              "count": filtered.length
            })

            item.actor_id = this.$route.params.id
            item.nombre_actor = item[f.value.replace("_id","")]
            item.group_id = f.value
            item.grupos = f.text

            planes[item.resolucion_poa_id] = item
            
          })
        })

        map(planes, (item, nth) => {
          if(!list_th.includes(nth))
            deduplicates.push(item)
            list_th.push(nth)
        })

        return deduplicates
      },
      byYears() {
        return groupBy(this.planes, 'departamento')
      },
      involucrado() {
        return find(this.planes, 'actor_id', this.$route.params.id)
      },
      grupos() {
        let grupos = {}
        map(groupBy(this.grupos_list, 'value'), (item, id) => {
          if(!grupos[id])
            grupos[id] = item[0]
        })

        return grupos
      },
      modalidades() {
        return map(groupBy(this.planes, 'modalidad'), (item, m) => {
          return {
            modalidad: m,
            count: item.length
          }
        })
      },
      byDepartamento(){
        let data = map(groupBy(this.planes, 'departamento' ),(item,departamento) =>{
          return {
            nombre: departamento,
            planes: item.length,
            modalidades: map(item, "modalidad"),
            volumen: sum(map(item, "vol_movilizado")),
            provincia: orderBy(map(groupBy(item, "provincia"), (d, prov) => {
              return {
                nombre: prov,
                count: d.length,
                distritos: orderBy(map(groupBy(d, "distrito"), (dis, distrito) => {
                  return {
                    nombre: distrito,
                    count: dis.length
                  }
                }), ['count'], ['desc']),
              }
            }), ['count'], ['desc']),
            distritos: orderBy(map(groupBy(item, "distrito"), (dis, distrito) => {
              return {
                nombre: distrito,
                count: dis.length
              }
            }), ['count'], ['desc']),
            slug: this.departamentoSlug(departamento),
            geodata: require(`../data/mapas/${this.departamentoSlug(departamento)}.json`)
          }      
        })
        
        return data
      }
    }
  }
</script>